<template>
  <div class="container">
    <section class="hero is-transparent is-fullheight">
      <!-- Hero head: will stick at the top -->
      <div class="hero-head">
        <header class="navbar">
          <div class="container">
            <div class="navbar-brand">
              <a class="navbar-item">
                <img
                  src="../assets/logo.png"
                  alt="Kjelling's data-høvleri"
                  class="k-logo"
                >
              </a>
            </div>
          </div>
        </header>
      </div>

      <!-- Hero content: will be in the middle -->
      <div class="hero-body">
        <div
          class="container has-text-centered text-container"
        >
          <h2 class="subtitle">
            Vi tilbyr spesialtilpassede web- og appløsninger med fokus på solid håndverk.
            Ta kontakt for tømring av solide full stack-systemer eller finspikking av brukervennlige og elegante grensesnitt.
          </h2>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "Home"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.text-container {
  background: rgba(255, 255, 255, 0.65);
  padding: 2rem 1rem;
  max-width: 60em;
}
.k-logo {
  min-height: 5rem;
  margin-top: 2.5rem;
  margin-left: 1rem;
}
</style>
